export default "__VITE_ASSET__VhZEsqJH__"